import React, { useCallback } from "react";
import {
  useMfaLoginOptions,
  enroll,
  useErrors,
} from "@auth0/auth0-acul-react/mfa-login-options";

type MfaLoginFactorType =
  | "push-notification"
  | "otp"
  | "sms"
  | "phone"
  | "voice"
  | "email"
  | "recovery-code"
  | "webauthn-roaming"
  | "webauthn-platform"
  | "duo";

const FACTOR_LABELS: Record<MfaLoginFactorType, string> = {
  "push-notification": "Push Notification (Auth0 Guardian)",
  otp: "One-Time Password (Authenticator App)",
  sms: "SMS",
  phone: "Phone Call",
  voice: "Voice Call",
  email: "Email",
  "recovery-code": "Recovery Code",
  "webauthn-platform": "Platform Authenticator",
  "webauthn-roaming": "Security Key",
  duo: "Notification via DUO app",
};

const MfaLoginOptionsScreen: React.FC = () => {
  const { tenant } = useMfaLoginOptions();
  const { hasError, errors } = useErrors();

  const handleFactorSelection = useCallback(async (factor: MfaLoginFactorType) => {
    await enroll({ action: factor });
  }, []);

  const enabled = (tenant.enabledFactors ?? []) as MfaLoginFactorType[];

  return (
    <div className="acul-card screen-mfa-login-options">
      <h2>Multi-factor Authentication</h2>
      <p>Choose a Multi-factor Authentication Method</p>

      {enabled.length === 0 ? (
        <div className="acul-empty">No authenticators available.</div>
      ) : (
        enabled.map((factor) => (
          <button key={factor} onClick={() => handleFactorSelection(factor)}>
            <span>{FACTOR_LABELS[factor] ?? factor}</span>
            <span>Use</span>
          </button>
        ))
      )}

      {hasError && (
        <div className="acul-error">
          {errors.map((err) => (
            <p key={err.id}>{err.message}</p>
          ))}
        </div>
      )}
    </div>
  );
};

export default MfaLoginOptionsScreen;
